module.exports = __webpack_public_path__ + "img/card_student_request_location.a668b6be.svg";